import { render, staticRenderFns } from "./education-guest.vue?vue&type=template&id=89915378&"
import script from "./education-guest.vue?vue&type=script&lang=js&"
export * from "./education-guest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports